// extracted by mini-css-extract-plugin
export var footer = "_or-5";
export var fulfillmentInput = "_or-0";
export var shipDateInput = "_or-1";
export var shipmentModal = "_or-2";
export var shipmentModalContent = "_or-3";
export var tableContainer = "_or-4";